import { defineComponent as _defineComponent } from 'vue';
import Dropdown from 'primevue/dropdown';
import { reactive, ref } from 'vue';
import { DateTime } from 'luxon';
import { required, integer, decimal, minValue } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { enumToDropdownOptions, processDataForm, processFormDocuments } from '../../../Services/Utils';
import { Salinity } from '../../../@types/Enums';
import { trans } from 'laravel-vue-i18n';
import { useSpinner } from '../../../Plugins/spinner';
import SaveCancelButtons from '../../../Components/SaveCancelButtons.vue';
import { useAxios } from '../../../Plugins/axios';
import { useMitt } from '../../../Plugins/mitt';
import DocumentsForm from '../../../Components/DocumentsForm.vue';
import RecordBasicInfo from '../RecordBasicInfo.vue';
import InputNumber from '../../../Components/InputNumber.vue';
import { useRoute } from '../../../Plugins/ziggy';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditCreate',
    props: {
        data: {
            type: Object,
            default: {},
        },
    },
    emits: ['saved', 'cancel'],
    setup(__props, { expose, emit }) {
        expose();
        const props = __props;
        const spinner = useSpinner();
        const axios = useAxios();
        const emitter = useMitt();
        const route = useRoute();
        const documentsForm = ref();
        const fields = [
            [
                {
                    field: 'ph',
                },
                {
                    field: 'electrical_conductivity',
                    unit: 'mS/cm',
                },
                {
                    field: 'calcium',
                    unit: 'mg/l',
                },
                {
                    field: 'magnesium',
                    unit: 'mg/l',
                },
                {
                    field: 'sodium',
                    unit: 'mg/l',
                },
            ],
            [
                {
                    field: 'potassium',
                    unit: 'mg/l',
                },
                {
                    field: 'chlorides',
                    unit: 'mg/l',
                },
                {
                    field: 'nitrates',
                    unit: 'mg/l',
                },
                {
                    field: 'sulfates',
                    unit: 'mg/l',
                },
                {
                    field: 'bicarbonates',
                    unit: 'mEq/l',
                },
                {
                    field: 'boron',
                    unit: 'mg/l',
                },
            ],
        ];
        const defaultDate = (props.data.date
            ? DateTime.fromISO(props.data.date, { zone: 'utc' })
            : DateTime.now()).toJSDate();
        const data = reactive({
            id: props.data.id,
            orchard_id: props.data.orchard_id,
            description: props.data.description || '',
            date: defaultDate,
            salinity: props.data.salinity,
            ph: props.data.ph,
            electrical_conductivity: props.data.electrical_conductivity,
            magnesium: props.data.magnesium,
            calcium: props.data.calcium,
            sodium: props.data.sodium,
            potassium: props.data.potassium,
            chlorides: props.data.chlorides,
            nitrates: props.data.nitrates,
            sulfates: props.data.sulfates,
            bicarbonates: props.data.bicarbonates,
            boron: props.data.boron,
        });
        const rules = {
            orchard_id: { required },
            description: { required },
            date: { required },
            salinity: { integer },
            ph: { decimal, minValue: minValue(0) },
            electrical_conductivity: { decimal, minValue: minValue(0) },
            magnesium: { decimal, minValue: minValue(0) },
            calcium: { decimal, minValue: minValue(0) },
            sodium: { decimal, minValue: minValue(0) },
            potassium: { decimal, minValue: minValue(0) },
            chlorides: { decimal, minValue: minValue(0) },
            nitrates: { decimal, minValue: minValue(0) },
            sulfates: { decimal, minValue: minValue(0) },
            bicarbonates: { decimal, minValue: minValue(0) },
            boron: { decimal, minValue: minValue(0) },
        };
        const v$ = useVuelidate(rules, data);
        const salinityOptions = enumToDropdownOptions(Salinity, 'Salinity');
        const newDocuments = ref([]);
        const save = async () => {
            const valid = await v$.value.$validate();
            if (!valid) {
                return;
            }
            documentsForm.value.upload();
            const formData = processDataForm(data, newDocuments.value, props.data.documents);
            let url = data.id
                ? route('api.irrigation-water-data.update', [data.id])
                : route('api.irrigation-water-data.store');
            spinner.show();
            axios
                .post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then((res) => {
                const data = res.data.data;
                emit('saved', data);
                emitter.emit('irrigation-water-data-saved', data);
            })
                .catch((err) => {
                console.log(err);
            })
                .finally(() => {
                spinner.hide();
            });
        };
        const __returned__ = { spinner, axios, emitter, route, documentsForm, props, emit, fields, defaultDate, data, rules, v$, salinityOptions, newDocuments, save, get Dropdown() { return Dropdown; }, get trans() { return trans; }, SaveCancelButtons, DocumentsForm, RecordBasicInfo, InputNumber };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
